import script from "./AppDeck.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDeck.vue?vue&type=script&setup=true&lang=ts"

import "./AppDeck.vue?vue&type=style&index=0&id=3f0a0b8f&scoped=true&lang=scss"

import exportComponent from "/home/dorian/programy/vue-draft/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0a0b8f"]])

export default __exports__